import React, { useEffect, useRef, useState } from 'react';
import { fetchAndDecryptLockFile, revokeObjectUrl } from '../utils/lockFileAccess';

export default function LockFolderStreamingVideo({
  item,
  lockSessionToken,
  masterKeyBytes,
  className = '',
  active = true,
  posterUrl,
  onError,
}) {
  const videoRef = useRef(null);
  const cleanupRef = useRef(null);
  const onErrorRef = useRef(onError);
  onErrorRef.current = onError;
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const video = videoRef.current;
    if (!video || !active || !item?.itemId || !lockSessionToken || !masterKeyBytes) {
      setLoading(false);
      return undefined;
    }
    let cancelled = false;

    const run = async () => {
      if (cleanupRef.current) {
        cleanupRef.current();
        cleanupRef.current = null;
      }
      video.removeAttribute('src');
      video.load();
      setLoading(true);

      const { blob } = await fetchAndDecryptLockFile(item, lockSessionToken, masterKeyBytes);
      if (cancelled) return;
      const url = URL.createObjectURL(blob);
      cleanupRef.current = () => revokeObjectUrl(url);
      video.src = url;
      setLoading(false);
    };

    run().catch((e) => {
      if (!cancelled) {
        setLoading(false);
        onErrorRef.current?.(e);
      }
    });

    return () => {
      cancelled = true;
      setLoading(false);
      if (cleanupRef.current) {
        cleanupRef.current();
        cleanupRef.current = null;
      }
      if (video) {
        video.pause();
        video.removeAttribute('src');
        video.load();
      }
    };
  }, [item?.itemId, lockSessionToken, masterKeyBytes, active]);

  return (
    <>
      {loading ? (
        <p className="mobile-media-viewer-overlay__loading" aria-live="polite">
          Decrypting video…
        </p>
      ) : null}
      <video
        ref={videoRef}
        className={className}
        controls
        playsInline
        poster={posterUrl || undefined}
        style={loading ? { visibility: 'hidden', position: 'absolute', width: 0, height: 0 } : undefined}
      />
    </>
  );
}
